import axios from "axios";

export const listPatches = () => axios.get("/api/admin/patches").then((r) => r.data);

// Returns { conflicts, cross_location_conflicts } - same-location hits can be
// overwritten, cross-location hits (name already used in the other folder)
// are a hard block, Data and events may never share a filename.
export const checkPatchConflicts = (filenames, location = "data") =>
  axios.post("/api/admin/patches/check", { filenames, location }).then((r) => r.data);

// Patch files run up to ~10 GB - no client-side timeout is set here (axios
// default is no timeout), and onUploadProgress drives the progress bar since
// a single request can take a very long time on a slow upstream link.
export const uploadPatches = (files, overwrite, location, onUploadProgress) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  formData.append("overwrite", overwrite ? "true" : "false");
  formData.append("location", location);
  return axios
    .post("/api/admin/patches/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    })
    .then((r) => r.data);
};

export const movePatch = (name, fromLocation, toLocation, overwrite = false) =>
  axios
    .post("/api/admin/patches/move", { name, from_location: fromLocation, to_location: toLocation, overwrite })
    .then((r) => r.data);
